import saveLinkData from "./saveLinkData";
import {openPopupInfo} from "../../../../../../../emitters/popup";
import {pushLocation} from "../../../../../../../router";
import {LINK_PBL} from "../../../../../../../constants/links";

export default ({id, formCtx}) => {
  const {state, setState, checkErrors} = formCtx;

  setState({loading: true});

  const data = (state || {}).data;

  const errors = checkErrors(data);

  const click = true;

  if (Object.keys(errors).length) {
    setState({click, errors, loading: false});
    return;
  }

  return saveLinkData(data, id)
      .then(() => (
        pushLocation({
          path: LINK_PBL,
        })
      ))
      .then(() => {
        openPopupInfo([
          'Changes saved',
          'You can view draft at Pay by Link page'
        ]);
      })
      .catch((e) => {
        const errors = {};
        errors['request'] = e.message;
        setState({loading: false, errors});
      });
}
